import React from "react";

export default function ScoreMeter({
  label,
  value,
  tone = "gold",
  suffix = "",
  compact = false,
}) {
  const colors = {
    gold: "from-[#F2DE94] via-[#D4AF37] to-[#9A7A1C]",
    forest: "from-[#7AD2A0] via-[#4AA36A] to-[#286641]",
    burgundy: "from-[#F5A8B5] via-[#B93A50] to-[#6B1C2C]",
    violet: "from-[#B6A4F2] via-[#6B4CDB] to-[#3C2A8F]",
  };
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      data-testid="score-meter"
      className={`w-full ${compact ? "" : "space-y-1.5"}`}
    >
      <div className="flex items-baseline justify-between gap-3">
        <span
          className={`text-white/60 ${compact ? "text-[11px]" : "text-xs"} tracking-[0.12em] uppercase`}
        >
          {label}
        </span>
        <span className={`font-display ${compact ? "text-sm" : "text-lg"}`}>
          {value}
          {suffix}
        </span>
      </div>
      <div className="h-[6px] w-full rounded-full bg-white/5 overflow-hidden">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${colors[tone]} transition-[width] duration-700`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
